import React from 'react'

import {
  Button,
  Icon,
} from '@cgtrader/triangle-ui/dist/src/ssr-index'
import {
  number, string, func, bool,
} from 'prop-types'

function SidebarButton({
  icon,
  iconColor,
  onClick,
  count,
  isActive,
  ariaLabel,
  role,
  ariaSelected,
  backgroundColor,
}) {
  return (
    <Button
      icon={(
        <span className={`review-sidebar-button__icon review-sidebar-button__icon--${backgroundColor}`}>
          <Icon svgComponent={icon} color={iconColor} size="small" />
        </span>
      )}
      type="secondary"
      variant="with-icon"
      onClick={onClick}
      customClass="review-sidebar-button"
      isActive={isActive}
      aria-label={ariaLabel}
      role={role}
      aria-selected={ariaSelected}
      tabIndex={0}
    >
      <span className="review-sidebar-button__count">{count}</span>
    </Button>
  )
}

SidebarButton.propTypes = {
  icon: func.isRequired,
  iconColor: string.isRequired,
  onClick: func.isRequired,
  count: number.isRequired,
  isActive: bool.isRequired,
  ariaLabel: string,
  role: string,
  ariaSelected: bool,
  backgroundColor: string.isRequired,
}

export default SidebarButton
